import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 8px 0px 4px 0px;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

export const DayWrapper = styled.p`
  margin: 0px;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const DateWrapper = styled.p<{ $isToday: boolean }>`
  margin: 0px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 4px;
  color: ${({ theme, $isToday }) => ($isToday ? theme.colors.white : theme.colors.black9)};
`;

export const TodayDate = styled.div<{ $isToday: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  padding: 4px;
  background-color: ${({ theme, $isToday }) => ($isToday ? theme.colors.purple7 : 'transparent')};
  border-radius: 50%;
`;
